export default __webpack_public_path__ + "static/media/running.92fd8984.svg";